function isActiveSchool(school) {
    let ret = school.properties[window.app.BoundarySelector.year_stage] === 'x';
    if (window.app.BoundarySelector.year.match(/^year[789]$/)) {
        ret =
            ret ||
            school.properties[
                `juniorsec_${window.app.BoundarySelector.stage}`
            ] === 'x';
    }

    // specialisation categories removed.
    // if (window.app.BoundarySelector.year === 'specialist' && window.app.BoundarySelector.selectedSpecialisationCategories) {
    //     ret = ret && window.app.BoundarySelector.selectedSpecialisationCategories.indexOf(school.properties.Specialisation) >= 0;
    // }
    return ret;
}

window.app = {
    env:
        window.location.host.match(/localhost/) &&
        !window.location.hash.match('prod')
            ? 'dev'
            : 'prod',
    schools: {},

    currentSchools() {
        return (
            window.app.schools[app.BoundarySelector.stage] || {
                type: 'FeatureCollection',
                features: [],
            }
        );
    },
    activeSchools() {
        return window.app.currentSchools().features.filter(isActiveSchool);
    },
    notActiveSchools() {
        return window.app
            .currentSchools()
            .features.filter((s) => !isActiveSchool(s));
    },
    stages: ['2026', '2027'],
    secondaryYears: [
        'year7',
        'year8',
        'year9',
        'year10',
        'year11',
        'year12',
        'juniorsec',
        'seniorsec',
        'singlesex',
    ],
};

window.app.schoolsLoading = (async () => {
    await Promise.all(
        window.app.stages.map((stage) =>
            window
                .fetch(`schools/schools-${stage}.json`)
                .then(
                    async (res) =>
                        (window.app.schools[stage] = await res.json())
                )
        )
    );
})();
